import { Checkbox, DataHeader, DataSource, Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutPayAdjustmentCode extends Layout {
    checkboxCityTaxFlag: Checkbox;
    checkboxCountyTaxFlag: Checkbox;
    checkboxCreatePayAdjustment: Checkbox;
    checkboxDispatcherFlag: Checkbox;
    checkboxEmpFicaHiFlag: Checkbox;
    checkboxEmpFicaOadiFlag: Checkbox;
    checkboxEmprFicaHiFlag: Checkbox;
    checkboxEmprFicaOadiFlg: Checkbox;
    checkboxEmprTrainFlag: Checkbox;
    checkboxExcludeCommissions: Checkbox;
    checkboxFederalTaxFlag: Checkbox;
    checkboxFuiFlagi: Checkbox;
    checkboxIsActive: Checkbox;
    checkboxIsCostBusiness: Checkbox;
    checkboxOverweightPay: Checkbox;
    checkboxPfmlFlag: Checkbox;
    checkboxSdiFlag: Checkbox;
    checkboxStateTaxFlag: Checkbox;
    checkboxSuiFlag: Checkbox;
    dataheaderPayAdjustmentCode: DataHeader;
    labelFederal: Label;
    labelG: Label;
    labelLocal: Label;
    labelState: Label;
    panelFederal: Panel;
    panelFederalColumn1: Panel;
    panelGeneral: Panel;
    panelLocal: Panel;
    panelLocalColumn1: Panel;
    panelState: Panel;
    panelStateColumn1: Panel;
    panelTaxes: Panel;
    sourceDeductCode: DataSource;
    textboxAmount: Textbox;
    textboxCodeType: Textbox;
    textboxGlid: Textbox;
    textboxId: Textbox;
    textboxShortDesc: Textbox;
    textboxWeightCutoff: Textbox;
}
